import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import generateClassesFromMap from '@insight/toolkit-utils/lib/generators/generateClassesFromMap';
import { LOZENGE_COLORS, LOZENGE_CLASS_MAP } from './classes';

const Lozenge = (props) => {
  const { bold, children, className, color } = props;

  const derivedClasses = generateClassesFromMap({ color }, LOZENGE_CLASS_MAP);

  const classes = cn(
    'c-lozenge',
    derivedClasses,
    {
      ' c-lozenge--bold': bold,
    },
    className
  );

  return <span className={classes}>{children}</span>
};

export default Lozenge;

Lozenge.propTypes = {
  bold: PropTypes.bool,
  color: PropTypes.oneOf(LOZENGE_COLORS),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Lozenge.defaultProps = {
  bold: false,
  className: '',
  color: null,
};
